<script>
    import { faCircleCheck, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";


    export let condition;
</script>

<div class="requirement" class:failed={!condition} class:fulfilled={condition}>
    <i>
        {#if condition}
            <Fa icon={faCircleCheck}/>
        {:else}
            <Fa icon={faTriangleExclamation}/>
        {/if}
    </i>
    <span class="text">
        <slot></slot>
    </span>
</div>

<style>
    .text {
        color: grey;
    }

    .failed>i {
        color: rgb(236, 192, 46);
    }

    .fulfilled>i {
        color: rgb(109, 197, 74);
    }
</style>